module.exports = __webpack_public_path__ + "static/media/tech-ecoRecycling.721b26a6.svg";